"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENTS_TO_TRACK = exports.COMMANDS_TO_TRACK = exports.INSERT_CALLOUT = exports.TOGGLE_VISUAL_BLOCKS = exports.DRAG_DROP_ANCHOR = exports.EDIT_ANCHOR = exports.INSERT_ANCHOR = exports.PASTE_CONTENT = exports.EDIT_TABLE = exports.INSERT_TABLE = exports.OPEN_TABLE_POPOVER = exports.INSERT_EMOJI = exports.OPEN_EMOJI_POPOVER = exports.APPLY_COLOR_MODAL = exports.OPEN_COLOR_MODAL = exports.APPLY_COLOR_POPOVER = exports.CHANGE_COLOR_POPOVER_MODE = exports.RESET_COLOR_TO_DEFAULT = exports.OPEN_COLOR_POPOVER = exports.EDIT_SOURCE_CODE = exports.OPEN_RSS_TOKEN = exports.INSERT_RSS_TOKEN = exports.OPEN_FORM_PICKER = exports.INSERT_HUBSPOT_VIDEO = exports.OPEN_VIDEO_PICKER = exports.EDIT_MEDIA_EMBED = exports.INSERT_MEDIA_EMBED = exports.OPEN_EMBED_MODAL = exports.UPDATE_CTA = exports.INSERT_CTA = exports.OPEN_CTA_PICKER = exports.INSERT_PERSONALIZATION_TOKEN = exports.OPEN_PROPERTY_BROWSER = exports.INSERT_LINK_TO_FILE = exports.OPEN_FILE_PICKER = exports.UPDATE_LINK = exports.INSERT_LINK = exports.ESCAPE_BLOCK_FORMAT = exports.CHANGE_BLOCK_FORMAT = exports.CHANGE_LINE_HEIGHT = exports.CHANGE_FONT = exports.CHANGE_FONT_SIZE = exports.AUTOMATIC_IMAGE_UPLOAD = exports.REPLACE_IMAGE = exports.REMOVE_IMAGE = exports.ALIGN_IMAGE = exports.INSERT_IMAGE = exports.OPEN_IMAGE_PICKER = void 0;

var SharedTrackingEvents = _interopRequireWildcard(require("rich-text-lib/constants/usageTracking"));

// hsimage
var OPEN_IMAGE_PICKER = SharedTrackingEvents.OPEN_IMAGE_PICKER;
exports.OPEN_IMAGE_PICKER = OPEN_IMAGE_PICKER;
var INSERT_IMAGE = SharedTrackingEvents.INSERT_IMAGE;
exports.INSERT_IMAGE = INSERT_IMAGE;
var ALIGN_IMAGE = SharedTrackingEvents.ALIGN_IMAGE;
exports.ALIGN_IMAGE = ALIGN_IMAGE;
var REMOVE_IMAGE = SharedTrackingEvents.REMOVE_IMAGE;
exports.REMOVE_IMAGE = REMOVE_IMAGE;
var REPLACE_IMAGE = SharedTrackingEvents.REPLACE_IMAGE;
exports.REPLACE_IMAGE = REPLACE_IMAGE;
var AUTOMATIC_IMAGE_UPLOAD = SharedTrackingEvents.AUTOMATIC_IMAGE_UPLOAD; // hsformatting

exports.AUTOMATIC_IMAGE_UPLOAD = AUTOMATIC_IMAGE_UPLOAD;
var CHANGE_FONT_SIZE = SharedTrackingEvents.CHANGE_FONT_SIZE;
exports.CHANGE_FONT_SIZE = CHANGE_FONT_SIZE;
var CHANGE_FONT = SharedTrackingEvents.CHANGE_FONT;
exports.CHANGE_FONT = CHANGE_FONT;
var CHANGE_LINE_HEIGHT = SharedTrackingEvents.CHANGE_LINE_HEIGHT;
exports.CHANGE_LINE_HEIGHT = CHANGE_LINE_HEIGHT;
var CHANGE_BLOCK_FORMAT = SharedTrackingEvents.CHANGE_BLOCK_FORMAT;
exports.CHANGE_BLOCK_FORMAT = CHANGE_BLOCK_FORMAT;
var ESCAPE_BLOCK_FORMAT = SharedTrackingEvents.ESCAPE_BLOCK_FORMAT; // hslink

exports.ESCAPE_BLOCK_FORMAT = ESCAPE_BLOCK_FORMAT;
var INSERT_LINK = SharedTrackingEvents.INSERT_LINK;
exports.INSERT_LINK = INSERT_LINK;
var UPDATE_LINK = SharedTrackingEvents.UPDATE_LINK; // hsfilelink

exports.UPDATE_LINK = UPDATE_LINK;
var OPEN_FILE_PICKER = SharedTrackingEvents.OPEN_FILE_PICKER;
exports.OPEN_FILE_PICKER = OPEN_FILE_PICKER;
var INSERT_LINK_TO_FILE = SharedTrackingEvents.INSERT_LINK_TO_FILE; // hspersonalize

exports.INSERT_LINK_TO_FILE = INSERT_LINK_TO_FILE;
var OPEN_PROPERTY_BROWSER = SharedTrackingEvents.OPEN_PROPERTY_BROWSER;
exports.OPEN_PROPERTY_BROWSER = OPEN_PROPERTY_BROWSER;
var INSERT_PERSONALIZATION_TOKEN = SharedTrackingEvents.INSERT_PERSONALIZATION_TOKEN; // hscta

exports.INSERT_PERSONALIZATION_TOKEN = INSERT_PERSONALIZATION_TOKEN;
var OPEN_CTA_PICKER = SharedTrackingEvents.OPEN_CTA_PICKER;
exports.OPEN_CTA_PICKER = OPEN_CTA_PICKER;
var INSERT_CTA = SharedTrackingEvents.INSERT_CTA;
exports.INSERT_CTA = INSERT_CTA;
var UPDATE_CTA = SharedTrackingEvents.UPDATE_CTA; // hsmedia

exports.UPDATE_CTA = UPDATE_CTA;
var OPEN_EMBED_MODAL = SharedTrackingEvents.OPEN_EMBED_MODAL;
exports.OPEN_EMBED_MODAL = OPEN_EMBED_MODAL;
var INSERT_MEDIA_EMBED = SharedTrackingEvents.INSERT_MEDIA_EMBED;
exports.INSERT_MEDIA_EMBED = INSERT_MEDIA_EMBED;
var EDIT_MEDIA_EMBED = SharedTrackingEvents.EDIT_MEDIA_EMBED; // hsvideo

exports.EDIT_MEDIA_EMBED = EDIT_MEDIA_EMBED;
var OPEN_VIDEO_PICKER = SharedTrackingEvents.OPEN_VIDEO_PICKER;
exports.OPEN_VIDEO_PICKER = OPEN_VIDEO_PICKER;
var INSERT_HUBSPOT_VIDEO = SharedTrackingEvents.INSERT_HUBSPOT_VIDEO;
exports.INSERT_HUBSPOT_VIDEO = INSERT_HUBSPOT_VIDEO;
var OPEN_FORM_PICKER = SharedTrackingEvents.OPEN_FORM_PICKER; // hsrsstokens

exports.OPEN_FORM_PICKER = OPEN_FORM_PICKER;
var INSERT_RSS_TOKEN = SharedTrackingEvents.INSERT_RSS_TOKEN;
exports.INSERT_RSS_TOKEN = INSERT_RSS_TOKEN;
var OPEN_RSS_TOKEN = SharedTrackingEvents.OPEN_RSS_TOKEN; // hscode

exports.OPEN_RSS_TOKEN = OPEN_RSS_TOKEN;
var EDIT_SOURCE_CODE = SharedTrackingEvents.EDIT_SOURCE_CODE; // hscolor

exports.EDIT_SOURCE_CODE = EDIT_SOURCE_CODE;
var OPEN_COLOR_POPOVER = SharedTrackingEvents.OPEN_COLOR_POPOVER;
exports.OPEN_COLOR_POPOVER = OPEN_COLOR_POPOVER;
var RESET_COLOR_TO_DEFAULT = SharedTrackingEvents.RESET_COLOR_TO_DEFAULT;
exports.RESET_COLOR_TO_DEFAULT = RESET_COLOR_TO_DEFAULT;
var CHANGE_COLOR_POPOVER_MODE = SharedTrackingEvents.CHANGE_COLOR_POPOVER_MODE;
exports.CHANGE_COLOR_POPOVER_MODE = CHANGE_COLOR_POPOVER_MODE;
var APPLY_COLOR_POPOVER = SharedTrackingEvents.APPLY_COLOR_POPOVER;
exports.APPLY_COLOR_POPOVER = APPLY_COLOR_POPOVER;
var OPEN_COLOR_MODAL = SharedTrackingEvents.OPEN_COLOR_MODAL;
exports.OPEN_COLOR_MODAL = OPEN_COLOR_MODAL;
var APPLY_COLOR_MODAL = SharedTrackingEvents.APPLY_COLOR_MODAL; // hsemoji

exports.APPLY_COLOR_MODAL = APPLY_COLOR_MODAL;
var OPEN_EMOJI_POPOVER = SharedTrackingEvents.OPEN_EMOJI_POPOVER;
exports.OPEN_EMOJI_POPOVER = OPEN_EMOJI_POPOVER;
var INSERT_EMOJI = SharedTrackingEvents.INSERT_EMOJI; // hstable

exports.INSERT_EMOJI = INSERT_EMOJI;
var OPEN_TABLE_POPOVER = SharedTrackingEvents.OPEN_TABLE_POPOVER;
exports.OPEN_TABLE_POPOVER = OPEN_TABLE_POPOVER;
var INSERT_TABLE = SharedTrackingEvents.INSERT_TABLE;
exports.INSERT_TABLE = INSERT_TABLE;
var EDIT_TABLE = SharedTrackingEvents.EDIT_TABLE; // hspaste

exports.EDIT_TABLE = EDIT_TABLE;
var PASTE_CONTENT = SharedTrackingEvents.PASTE_CONTENT; // hsanchor

exports.PASTE_CONTENT = PASTE_CONTENT;
var INSERT_ANCHOR = SharedTrackingEvents.INSERT_ANCHOR;
exports.INSERT_ANCHOR = INSERT_ANCHOR;
var EDIT_ANCHOR = SharedTrackingEvents.EDIT_ANCHOR;
exports.EDIT_ANCHOR = EDIT_ANCHOR;
var DRAG_DROP_ANCHOR = SharedTrackingEvents.DRAG_DROP_ANCHOR; // hsvisualblocks

exports.DRAG_DROP_ANCHOR = DRAG_DROP_ANCHOR;
var TOGGLE_VISUAL_BLOCKS = SharedTrackingEvents.TOGGLE_VISUAL_BLOCKS; // hscallout

exports.TOGGLE_VISUAL_BLOCKS = TOGGLE_VISUAL_BLOCKS;
var INSERT_CALLOUT = SharedTrackingEvents.INSERT_CALLOUT;
exports.INSERT_CALLOUT = INSERT_CALLOUT;
var COMMANDS_TO_TRACK = {
  Copy: 'cut',
  Cut: 'copy',
  Indent: 'indent',
  InsertHorizontalRule: 'insert-horizontal-rule',
  InsertUnorderedList: SharedTrackingEvents.MAKE_UNORDERED_LIST,
  InsertOrderedList: SharedTrackingEvents.MAKE_ORDERED_LIST,
  JustifyCenter: 'align-center',
  JustifyLeft: 'align-left',
  JustifyRight: 'align-right',
  JustifyNone: 'remove-alignment',
  mcehsmore: 'insert-read-more',
  // 'mceInsertClipboardContent',
  mceNonBreaking: 'insert-nonbreaking-space',
  mceTableCellProps: 'edit-table-cell-properties',
  mceTableCopyRow: 'copy-table-row',
  mceTableCutRow: 'cut-table-row',
  mceTableDelete: 'delete-table',
  mceTableDeleteCol: 'delete-table-column',
  mceTableDeleteRow: 'delete-table-row',
  mceTableInsertColAfter: 'insert-table-column-after',
  mceTableInsertColBefore: 'insert-table-column-before',
  mceTableInsertRowAfter: 'insert-table-row-after',
  mceTableInsertRowBefore: 'insert-table-row-before',
  mceTableMergeCells: 'merge-table-cells',
  mceTablePasteRowAfter: 'paste-table-row-after',
  mceTablePasteRowBefore: 'paste-table-row-before',
  mceTableRowProps: 'edit-table-row-properties',
  mceTableSplitCells: 'split-table-cells',
  mceToggleFormat: SharedTrackingEvents.CHANGE_INLINE_STYLE,
  mceVisualBlocks: 'toggle-visual-blocks',
  Outdent: 'outdent',
  redo: 'redo',
  RemoveFormat: 'remove-formatting',
  SelectAll: 'select-all',
  undo: 'undo',
  SearchReplace: 'SearchReplace'
};
exports.COMMANDS_TO_TRACK = COMMANDS_TO_TRACK;
var EVENTS_TO_TRACK = {
  colorChanged: APPLY_COLOR_POPOVER,
  editSource: EDIT_SOURCE_CODE,
  insertAnchor: INSERT_ANCHOR,
  insertTable: INSERT_TABLE,
  insertSpecialCharacter: 'insert-special-character',
  pasteFromWord: 'paste-from-word',
  paste: PASTE_CONTENT
};
exports.EVENTS_TO_TRACK = EVENTS_TO_TRACK;